import { render, staticRenderFns } from "./AcademicInformation.vue?vue&type=template&id=4a1cec5e&scoped=true"
import script from "./AcademicInformation.vue?vue&type=script&lang=js"
export * from "./AcademicInformation.vue?vue&type=script&lang=js"
import style0 from "./AcademicInformation.vue?vue&type=style&index=0&id=4a1cec5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1cec5e",
  null
  
)

export default component.exports